import { v4 as uuid } from 'uuid';

const DEFAULT_POPULATIONS = [
  {
    key: 0,
    id: 0,
    name: 'Rule0',
    eligibility: {},
    localOverride: {},
  },
];

export const getNewRule = () => ({
  key: uuid(),
  eligibility: {},
  formula: [],
  localOverride: {},
});

export const RULES_KEYS = {
  compensation: 'compensationRules',
  midpoint: 'midpointRules',
};

export default {
  populations: DEFAULT_POPULATIONS,
  [RULES_KEYS.compensation]: [getNewRule()],
  [RULES_KEYS.midpoint]: [getNewRule()],
  systemVariables: [],
  eligibilityOperators: [],
  formulaOperators: [],
  lookUpValues: {},
  includeDisclaimer: false,
  disclaimer: '',
  savedId: '',
  savedEtag: '',
  status: '',
  errors: {
    populations: [],
    [RULES_KEYS.compensation]: [],
    [RULES_KEYS.midpoint]: [],
    disclaimer: '',
  },
};
